import { Button, Dialog, DialogActions, DialogContent, DialogTitle,IconButton, TextField } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonSearch from "../../../SharedFiles/CommonSearch/CommonSearch";
import DynamicTable from "../../../SharedFiles/CommonTable/dynamicTable";
import { toast, Toaster } from 'react-hot-toast';
import { GetPoData, GetPOINVPINPUT, PostPOINVPINPUT } from "../../../APIServices/ProductionService/ProductionFgService/ProductionFgThunk";
import { convertCase, parseFormattedQRText, validateDecimalInput } from "../../../SharedFiles/Helper/utils";
import CloseIcon from '@mui/icons-material/Close'; 
import QrContainer from '../../../SharedFiles/QRCode/qrReader';
import { useTranslation } from 'react-i18next';

const ProductionTransfer = ({ transferModal,  openManual,setOpenManual, setTransferModal,batchInfo}) => {
    // const { GetToWarehouse, loading, error } = useSelector((state) => state.InvTransfer || {});
    const { POINVPINPUT, POINVPINPUTPost, error, loading } = useSelector((state) => state.ProductionFg);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const InputFields = ['batch_Number'];
    const [tableRows, setTableRows] = useState([]);
    const [postTrigger, setPostTrigger] = useState(false);
    const [errorMessage, setErrorMessage] = useState({});
    const [batchNum,setBatchNum]=useState({});
    const [QrTrigger, setQrTrigger] = useState(false);
    const initialValues = [{
        quantity: 0,
        item_Code: "",
        Batch_Number: "",
        from_Whs: "",
        toWhs: "",
        remarks: "",
        absEntry: ""
    }]
    const [values, setValues] = useState(initialValues);


    // useEffect(() => {
    //     if (QrTrigger) {
    //         const item = POINVPINPUT && POINVPINPUT.filter(item => item.batch_Number=== batchNum.Batch_Number);
    //         if (item.length === 0) {
    //             toast.error(t("Batch Number not found!"));
    //         } else {
    //         handleDropdownClick(item[0]);
    //       setOpenManual(true); 
    //     }
    //     setQrTrigger(false); 
    // }
    //   }, [QrTrigger]);

    useEffect(() => {
        if (postTrigger && POINVPINPUTPost === 'Success') {
            toast.success(t('Transferred successfully'));
            dispatch(GetPoData());
            setTransferModal(false);
            setTableRows([]);
            setValues(initialValues);
            setPostTrigger(false);
        }
        if (postTrigger && error.POINVPINPUTPostError) {
           
            const errorses =error.POINVPINPUTPostError;
            toast.error(`${errorses.errorMessage}`);
            setPostTrigger(false);
            // dispatch(resetError());
        }
    }, [POINVPINPUTPost, error, postTrigger]);

    //   useEffect(() => {
    //     if ((POINVPINPUT || POINVPINPUT?.length < 1)) {
    //         setTableRows([POINVPINPUT[0]]);           
    //     }
    // }, [POINVPINPUT]);

    // useEffect(() => {
    //     if ((!POINVPINPUT || POINVPINPUT.length === 0) && batchItem) {
    //         dispatch(GetPOINVPINPUT({ ItemCode: batchItem }));
    //     }
    // }, [POINVPINPUT, dispatch]);
    const excludedFields = ['docEntry', 'u_STATUS', 'absEntry', 'batch_Number', 'onHand'];
    const tableHeader = useMemo(() => {
        return POINVPINPUT?.length > 0
            ? Object.keys(POINVPINPUT[0]).filter(header => !excludedFields.includes(header))
            : [];
    }, [POINVPINPUT]);
    const handleTransferClose = () => {
        setTransferModal(false);
        setTableRows('');
        setValues('');

    };
    const handleDropdownClick = (item, fieldname) => {
        setValues(item)
        setTableRows([item]);
    }
    const handleActualeight = (e, field) => {
        let value = e.target.value;
        const { isValid, values: cleanedValue, error } = validateDecimalInput(value);
       if(isValid) {
        const difference = parseInt(cleanedValue) - parseFloat(values.net_Weight);
        setValues((prevValues) => ({
            ...prevValues,
            [field]: cleanedValue,
            difference:difference
          }));
          const updatedTableRows = [...tableRows]; // Create a shallow copy of tableRows array
          updatedTableRows[0] = {
              ...updatedTableRows[0], // Create a shallow copy of the first row object
              [field]: value, 
              difference:difference
          };
      setTableRows(updatedTableRows); 
        }
      
         
    }
    // const onDelete = (action, rowIndex) => {
    //     // Create a new array without the deleted row
    //     const updatedTableRows = tableRows.filter((_, index) => index !== rowIndex);

    //     // Update the table rows state to reflect the change
    //     setTableRows(updatedTableRows);
    // };
    //   const handleQrScan = (scanResult) => {
    //     setQrTrigger(true);        
    //       scanResult = JSON.parse(scanResult);
    //     if (scanResult && typeof scanResult === "object" && scanResult.Batch_Number) {
    //         setValues((prevFormData) => {
    //         let updatedFormData = { ...prevFormData };
    //         updatedFormData.Batch_Number = scanResult.Batch_Number;
    //         return updatedFormData;
    //       });
    //       setBatchNum(scanResult);
         
    //     } else {
    //       toast.error(t('Batch Number is missing in the scan result'));
    //     }
    //   };
    const handleQrScan = (scanResult) => {
        // let data;
        // try {
        //     data = parseFormattedQRText(scanResult);
        // } catch (err) {
        //     console.error("Invalid QR scan result:", err);
        //     return;
        // } const batchNumber = data?.BatchNumber?.trim();
        const batchNumber = scanResult["batchnumber"].trim();
        if (!batchNumber) {
            toast.error(t('Batch Number not found!'));
            return;
        }
        const matchBatchNumer = POINVPINPUT&&POINVPINPUT?.filter(
            item => item.batch_Number?.toLowerCase() === batchNumber.toLowerCase()
        );
    
        if (!matchBatchNumer) {
            toast.error(t('No matching records found.'));
            return;
        }
        setOpenManual(!openManual)
        handleDropdownClick(matchBatchNumer[0]);
    }
    const handleTransferPost = () => {
        let newErrorMessage = {};        
        const weight  = parseFloat(tableRows[0].net_Weight);
        const actualWeight = parseFloat(tableRows[0].actual_weight);
        if (actualWeight < weight - 100 || actualWeight > weight + 100) {
          toast.error(
            `Weight must be within ±100 of the tolerance value (${weight}).`
          )
          return;
        }
        if(!values.actual_weight){
            toast.error("Weight is required")
        }else{
            const currentWhsQty = tableRows && tableRows[0] ? tableRows[0].onHand : 0;
            const updatedWhsQty = !isNaN(currentWhsQty) && !isNaN(tableRows[0].difference)
                ? (currentWhsQty + parseFloat(tableRows[0].difference))
                : currentWhsQty;  
            const datapost = tableRows.map((row) => ({
                poDocEntry: batchInfo.docEntry,
                itemCode: row.item_Code,
                uomQty: updatedWhsQty,
                batchNo: row.batch_Number,
                batchQty: row.difference,
                absEntry: row.absEntry,
                quantity: row.actual_weight,
                from_Whs: "SFG",
                toWhs: "MLD",
                // remarks: "string",
            }));        
            setPostTrigger(true);
            dispatch(PostPOINVPINPUT(datapost));
            // Dispatch the updated table data to the postITR action
            // dispatch(postITR(datapost));
        }
        // if (!values.difference) {
        //     newErrorMessage.difference = `Weight can't empty`;
        // }
        
        // // If any error exists, update error state and return early
        // if (Object.keys(newErrorMessage).length > 0) {
        //     setErrorMessage(newErrorMessage);
        //     return; // Prevent further processing after the first error
        // }
        
        
    };
    return (
        <Dialog open={transferModal} >
            <DialogTitle className="Modal-heading">Inventory Posting
            <IconButton 
                  edge="end" 
                  color="inherit" 
                  onClick={handleTransferClose}
                  style={{ position: 'absolute', right: '18px', top: '10px' }}>
               <CloseIcon />
               </IconButton>
            </DialogTitle>
            <DialogContent className="custom-dialog-content">
            {openManual ? (
                <div className="transfer-data">
                    <CommonSearch
                        inputFields={InputFields}
                        data={POINVPINPUT}
                        values={values}
                        setValues={setValues}
                        handleDropdownClick={handleDropdownClick} />

                    {tableHeader && tableHeader.map((field, index) => (
                        <div key={index} className=" mb-3 position-relative">
                            <label htmlFor={field} className="custom-label">{t(convertCase(field))}</label>
                            <input
                                type="text"
                                id={field}
                                className="form-control custom-input"
                                autoComplete="off"
                                disabled={field !== 'actual_weight'} 
                                onChange={(e) => {
                                    if (field === 'actual_weight') {
                                        handleActualeight(e, field);
                                    }
                                }}
                                value={tableRows && tableRows[0] ? tableRows[0][field] : ''}
                                helperText={errorMessage && errorMessage[field]} 
                                error={errorMessage&errorMessage[field]}
                            />
                              {/* {errorMessage[field] && (
                             <div className="error-message">
                                        {errorMessage[field]}
                             </div>
                                )} */}
                        </div>
                    ))}

                    {/* {tableHeader?.length > 0 &&
                        <DynamicTable
                            header={tableHeader}
                            tablebody={tableRows}
                            pageName={'Disassemble'}
                            // onEdit={onEdit}
                            // onDelete={onDelete}
                            // onPrint={onPrint}
                        />} */}
                </div>
                 ) : (
                    <div>
                    <QrContainer  openManual={openManual} elementId="ProductionFg-Trans" onScan={handleQrScan}   />
                    </div>
                )}
            </DialogContent>
            <DialogActions className="custom-dialog-actions">
            <Button onClick={() => setOpenManual(!openManual)}>
                    {openManual ? "Scanner" : "Manual"}
                </Button>
                <Button onClick={handleTransferClose} className='Modal-cancel'>Cancel</Button>
                <Button onClick={handleTransferPost} className='Modal-submit'>Posting</Button>
            </DialogActions>
            </Dialog>
    );
};

export default ProductionTransfer;